<app-floating-configurator />

<div class="notfound-container">
    <div class="notfound-content">
      

        <div class="card-outer-border">
            <div class="card-inner">
                <span class="status-code">404</span>
                <h1 class="status-title">Page Not Found</h1>
                <p class="status-subtitle">The resource you are looking for is not available or has been moved.</p>

                <div class="links-section">
                    <a routerLink="/" class="helper-link">
                        <span class="icon-box">
                            <i class="pi pi-fw pi-table"></i>
                        </span>
                        <span class="link-text">
                            <span class="title">Go to Dashboard</span>
                            <span class="description">Return to your main workspace overview.</span>
                        </span>
                    </a>

                    <a routerLink="/" class="helper-link">
                        <span class="icon-box">
                            <i class="pi pi-fw pi-question-circle"></i>
                        </span>
                        <span class="link-text">
                            <span class="title">Solution Center</span>
                            <span class="description">Find answers to common platform questions.</span>
                        </span>
                    </a>
                </div>

                <p-button label="Return Home" icon="pi pi-home" routerLink="/" styleClass="mt-6" />
            </div>
        </div>
    </div>
</div>